import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

@Component({
    selector: 'pagination',
    standalone: false,
    templateUrl: './pagination.component.html',
    styles: [`.pagination { --bs-pagination-padding-y: 0.05rem; }`]
})
export class PaginationComponent implements OnInit, OnChanges {

    @Input() total: number;
    @Input() page: number;
    @Input() pageSize: number;

    @Output() first = new EventEmitter<number>();
    @Output() last = new EventEmitter<number>();

    @Output() change = new EventEmitter<number>();

    array: any = [];
    totalPage = 0;

    arraySize = 7

    ngOnInit() {
        this.pageSize = this.pageSize || 10;
        this.totalPage = Math.ceil(this.total / this.pageSize);
        this.changePages();
    }

    ngOnChanges() {
        this.changePages();
    }

    changePages() {
        if (this.totalPage > this.arraySize) {
            this.array = this.arraySize / this.page > 2 ?
                Array.from(Array(this.arraySize), (_, i) => i + 1) :
                Array.from(Array(this.arraySize), (_, i) => (i + 1) + this.page - 4);
        } else {
            this.array = Array.from(Array(this.totalPage), (_, i) => i + 1)
        }
    }

}
